import React, { FC } from 'react';

import { CONFIRMATION_CODE_RE_ENTER } from '../../Utilities/Constant';

export const CodeMismatchExceptionError: FC = () => <>{CONFIRMATION_CODE_RE_ENTER}</>;
